<template>
	<div class="main-containter" id="top" v-title data-title="和华利盛-首页">
		<FHeader :checkId="0"></FHeader>
		<FBanner></FBanner>
		<!-- <FTitle></FTitle> -->
		<article>
			<div class="about" style="">
				<!-- <FContentTitle :titleName="titleName1"></FContentTitle> -->
				<FHomeAbout></FHomeAbout>
			</div>
			<div class="" style="">
				<FHomeBusinessArea></FHomeBusinessArea>
			</div>
			<div class="">
				<FHomeInformation></FHomeInformation>
			</div>
			<div class="">
				<FHomePanter></FHomePanter>
			</div>
			<!-- <div class="business">
				<FContentTitle :titleName="titleName2"></FContentTitle>
				<FHomeBusiness :data="softwareList"></FHomeBusiness>
			</div>
			<div class="scenic">
				<FContentTitle :titleName="titleName3"></FContentTitle>
				<FHomeScenic :data="scenicList"></FHomeScenic>
			</div> -->
			<!-- <div class="news"> -->
				<!-- <FContentTitle :titleName="titleName4"></FContentTitle> -->
				<!-- <FHomeNews :data="newsList"></FHomeNews> -->
			<!-- </div> -->
		</article>
		<Footer></Footer>
	</div>
</template>

<script>
	import FHeader from "../../components/f/FHeader.vue"
	import FBanner from "../../components/f/FBanner.vue"
	// import FTitle from "../../components/f/FTitle.vue"
	// import FContentTitle from "../../components/f/FContentTitle.vue"
	import FHomeAbout from "../../components/f/FHomeAbout.vue"
	import FHomeInformation from "../../components/f/FHomeInformation.vue"
	import FHomeBusinessArea from "../../components/f/FHomeBusinessArea.vue"
	import FHomePanter from "../../components/f/FHomePanter.vue"
	// import FHomeBusiness from "../../components/f/FHomeBusiness.vue"
	// import FHomeScenic from "../../components/f/FHomeScenic.vue"
	// import FHomeNews from "../../components/f/FHomeNews.vue"
	import Footer from "../../components/f/Footer.vue"

	import {queryScenicList,querySoftwareList,queryArticleList,isLock} from "@/api/front";
	export default {
		name: "Index",
		components: {
			FHeader,
			FBanner,
			// FTitle,
			// FContentTitle,
			FHomeAbout,
			FHomePanter,
			FHomeInformation,
			FHomeBusinessArea,
			// FHomeBusiness,
			// FHomeScenic,
			// FHomeNews,
			Footer
		},
		data() {
			return {
				titleName1: '关于我们',
				titleName2: '核心业务',
				titleName3: '业务景区',
				titleName4: '新闻聚焦',
				softwareList: [],
				scenicList:[],
				newsList:[],
			}
		},
		mounted() {
			this.isLock()
			if (this._isMobile()) {
				// this.$router.replace('/mb_index')
				this.$router.push(
					{
						path:'/phoneIndex',
					}
				);
			} else {
				console.log('pc端')
				this.scrollcolor()
				this.queryScenic(5)
				this.querySoftware(6)
				this.queryArticle(11)	
				// this.$router.replace('/pc_index')
			}
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			isLock(){
				isLock().then(data => {
					console.log("软件",data.data)
					if(data.data == 2){
						this.$router.push(
							{
								path:'/notOpen',
							}
						);
					}
				}).catch(error => {
					console.log("软件",error)
				})
			},
			_isMobile () {
				let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
				return flag
			},
			scrollcolor() {
				this.$nextTick(() => {
					window.onscroll = function() {
						let header = document.getElementById('header')
						let item = header.getElementsByClassName('item')
						if (window.pageYOffset>0) {
							// navbox.style.backgroundColor="#FFFFFF"
						} else {
							// navbox.style.backgroundColor="#FFFFFF"
						}
					}
				})
			},
			querySoftware(id){
				let param = {
					title: '',
					channelId: id,
					page: 1,
					pageSize: 3,
				}
				querySoftwareList(param).then(data => {
					this.softwareList=data.data.list
					// console.log("软件",this.softwareList)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			queryScenic(id){
				let param = {
					title: '',
					channelId: id,
					page: 1,
					pageSize: 3,
				}
				queryScenicList(param).then(data => {
					this.scenicList=data.data.list
					// console.log("景区",this.scenicList)
				}).catch(error => {
					this.$message.error(error)
				})
			},
			queryArticle(id){
				let param = {
					title: '',
					channelId: id,
					page: 1,
					pageSize: 4,
				}
				queryArticleList(param).then(data => {
					this.newsList=data.data.list
					// console.log("新闻",this.newsList)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.main-containter {
		min-width: 1000px;
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
</style>
